import { useMutation, useQueryClient } from '@tanstack/react-query';

interface BulkUnchainParams {
  custom_tag_id: number;
}

/**
 * 該当しない求職者の紐付けを一括解除するフック
 * エンドポイントは求人タグと共通（tag_type 非依存）
 */
export default function useBulkUnchain() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;

  return useMutation({
    mutationFn: async (params: BulkUnchainParams) => {
      const { custom_tag_id } = params;
      const response = await fetch(`/agent/api/custom_tags/${custom_tag_id}/bulk_unchain`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to bulk unchain');
      }

      return response.json();
    },
    onSuccess: (_, variables) => {
      // 求職者タグ一覧を再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/candidate_profile_tags'],
      });
      // 条件一覧も再取得
      queryClient.invalidateQueries({
        queryKey: ['/agent/api/custom_tags', variables.custom_tag_id, 'conditions'],
      });
    },
  });
}
